import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';
import domReady from '@wordpress/dom-ready';
import { Fancybox } from '@fancyapps/ui';

domReady(() => {
  Fancybox.bind('[data-fancybox]', {});

  const carousels = document.querySelectorAll(
    '.solution-slider-horizontal__swiper'
  );

  carousels.forEach((el) => {
    const root = el.closest('.solution-slider-horizontal');

    if (!root) {
      return;
    }

    const nav = root.querySelector('.solution-slider-horizontal__nav');
    const a11y = { enabled: true };

    if (nav) {
      a11y.prevSlideMessage = nav.dataset.prevLabel;
      a11y.nextSlideMessage = nav.dataset.nextLabel;
    }

    new Swiper(el, {
      modules: [Pagination],
      slidesPerView: 1.2,
      autoHeight: true,
      spaceBetween: 30,
      watchOverflow: true,
      keyboard: { enabled: true },
      a11y,
      navigation: {
        prevEl: root.querySelector('.solution-slider-horizontal__prev'),
        nextEl: root.querySelector('.solution-slider-horizontal__next'),
      },
      pagination: {
        el: root.querySelector('.solution-slider-horizontal__fraction'),
        type: 'fraction',
        renderFraction(currentClass, totalClass) {
          return `<span class="${currentClass}"></span>/<span class="${totalClass}"></span>`;
        },
      },
    });
  });
});
